import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InViewportModule } from 'ng-in-viewport';

import { SharedComponentsModule } from '../shared/directives/shared-components.module';
import { FocusOnLoadModule } from '../shared/focus-on-load/focus-on-load.module';
import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { InstrumentationModule } from '../shared/instrumentation/instrumentation.module';
import { FolderComponent } from './folder/folder.component';
import { FoldersComponent } from './folders.component';

@NgModule({
    imports: [
        CommonModule,
        FocusOnLoadModule,
        IconFontModule,
        InstrumentationModule,
        InViewportModule,
        SharedComponentsModule
    ],
    declarations: [
        FolderComponent,
        FoldersComponent
    ],
    exports: [
        FoldersComponent
    ]
})
export class FoldersModule { }
